import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-sub-menu-options',
  templateUrl: './sub-menu-options.component.html',
  styleUrls: ['./sub-menu-options.component.scss']
})
export class SubMenuOptionsComponent implements OnInit {
  @Input() options: any[];
  @Input() canShowMobileSubmenu: boolean = false;
  constructor(private readonly cdRef: ChangeDetectorRef) { }

  ngOnInit(): void { }

  closeSidebar() {
    const sideBarElement = document.getElementById('leftSidebarMenu');
    if (sideBarElement) {
      document.body.classList.remove('pmd-body-open');
      sideBarElement.classList.remove('sidebar-open');
      // ✅ Remove the generated div
      const extraDiv = document.querySelector('.pmd-sidebar-overlay');
      if (extraDiv) {
        extraDiv.remove();
      }
      this.cdRef.detectChanges();
    }
  }
}
